import { FieldConfig } from "../types/formTypes";

export const managerInfoFields: FieldConfig[] = [
  {
    name: "empNuid",
    label: "Employee NUID",
    type: "text",
    disabled: true,
    helperText: "Network user ID of the employee",
  },

  {
    name: "empHomeEmail",
    label: "Preferred email address",
    type: "text",
    disabled: true,
    helperText: "Email used for communication",
  },

  {
    name: "managerName",
    label: "Direct Manager",
    type: "text",
    disabled: true,
    helperText: "Manager assigned via HR connect",
  },
];

export const applicationFields: FieldConfig[] = [
  {
    name: "filingFees",
    label: "N400 filing Fees",
    type: "number",
    disabled: true,
    helperText: "Citizenship filing fees ",
  },
  {
    name: "n400ApplicationDate",
    label: "N400 Application date",
    type: "date",
    helperText: "Date of N400 submission",
    disabled: true,
  },
  {
    name: "biometricFees",
    label: "Biometrics fees",
    type: "number",
    helperText: "Fee for biometrics services",
    disabled: true,
  },
  {
    name: "classSchoolName",
    label: "Class/School name",
    type: "text",
    disabled: true,
    helperText: "Institution or agency name",
  },
  {
    name: "totalClassFees",
    label: "Total class fees",
    type: "number",
    helperText: "Sum of all  fees entered",
    disabled: true,
  },

  {
    name: "classStartDate",
    label: "Class start date",
    type: "date",
    disabled: true,
    helperText: "Start date of the class or program",
  },
  {
    name: "classEndDate",
    label: "Class end date",
    type: "date",
    helperText: "End date of the class or program",
    disabled: true,
  },
  {
    name: "comments",
    label: "Employee comments",
    type: "textarea",
    disabled: true,
  },
];

export const mangerInformationFields: FieldConfig[] = [
  {
    name: "empNuid",
    label: "Employee NUID",
    type: "text",

    helperText: "Network user ID of the employee",
    disabled: true,
  },
  {
    name: "empHomeEmail",
    label: "Preferred email address",
    type: "text",
    helperText: "Email used for communication",
    disabled: true,
  },
  {
    name: "managerName",
    label: "Direct managers",
    type: "text",
    helperText: "Manager assigned via HR connect",
    disabled: true,
  },

  {
    name: "altManagerName",
    label: "Self reported manager",
    type: "text",
    required: false,
    helperText: "Manager assigned via HR connect",
    disabled: true,
  },
];

export const paidDayOffFields: FieldConfig[] = [
  {
    name: "paidDayOffhours",
    label: "Paid day off hours",
    type: "number",
    helperText: "Please enter a valid number between 1 and 24",
    validations: [
      {
        type: "requiredIf",
        condition: (formData) => !!formData.paidDayOffdate,
        message: "Paid day off hours is required when a date is entered.",
      },
      {
        type: "min",
        value: 1,
        message: "Enter a number between 1 and 24.",
      },
      {
        type: "max",
        value: 24,
        message: "Enter a number between 1 and 24.",
      },
    ],
  },
  {
    name: "paidDayOffdate",
    label: "Paid day off date",
    type: "date",
    helperText: "MM/DD/YYYY",
    validations: [
      {
        type: "requiredIf",
        condition: (formData) => !!formData.paidDayOffhours,
        message: "Paid day off date is required when hours are entered.",
      },
      {
        type: "dateFormat",
        message: "Enter a valid date in MM/DD/YYYY format.",
      },
    ],
  },
];

export const uploadDocumentFields: FieldConfig[] = [
  {
    name: "documentFile",
    label: "Document file",
    type: "file",
    required: false,
    validations: [
      {
        type: "custom",
        validator: (value) => {
          if (!value) return true; // If no file, validation passes
          const fileName = typeof value === 'string' ? value : value.name;
          const allowedExtensions = /\.(pdf|jpg|jpeg|png|doc|docx)$/i;
          return allowedExtensions.test(fileName);
        },
        message: "Only PDF, JPG, PNG, DOC, and DOCX files are allowed.",
      },
    ],
  },
  {
    name: "documentFileSize",
    label: "Document file size",
    type: "file",
    required: false,
    validations: [
      {
        type: "custom",
        validator: (value) => {
          if (!value) return true; // If no file, validation passes
          const fileSize = typeof value === 'number' ? value : 0;
          const maxSizeInBytes = 10 * 1024 * 1024; // 10MB in bytes
          return fileSize <= maxSizeInBytes;
        },
        message: "File size must not exceed 10 MB.",
      },
    ],
  },
  {
    name: "contentDescription",
    label: "Describe the contents",
    type: "textarea",
    required: false,
    helperText: "1000 of 1000 characters left",
    validations: [
      {
        type: "requiredIf",
        condition: (formData) => !!formData.documentFile,
        message: "A comment is required for each uploaded document.",
      },
      {
        type: "maxLength",
        value: 1000,
        message: "Description must not exceed 1000 characters.",
      },
    ],
  },
];
